module.exports = __webpack_public_path__ + "img/training-0-4.2682612e.jpg";